'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import { nanoid } from 'nanoid';
import { Icon } from '../Icon/Icon.js';
export const AccordionPanel = (_a) => {
    var { children, className, header, ariaLabelledBy, isActive, ariaControls, disabled, titleAfter, iconSize = 'lg' } = _a, other = __rest(_a, ["children", "className", "header", "ariaLabelledBy", "isActive", "ariaControls", "disabled", "titleAfter", "iconSize"]);
    const panelRef = React.useRef(null);
    const [heightVar, setHeight] = React.useState('0');
    const [isActiveVar, setIsActive] = React.useState(isActive ? true : false);
    const [ariaControlsVar, setAriaControls] = React.useState();
    const [ariaLabelledByVar, setAriaLabelledBy] = React.useState();
    React.useEffect(() => {
        function setInitialPanelHeight() {
            var _a;
            if (!panelRef.current)
                return;
            const scrollHeight = (_a = panelRef.current.querySelector('.sparky-c-accordion-panel__body-inner')) === null || _a === void 0 ? void 0 : _a.scrollHeight;
            if (isActiveVar) {
                if (scrollHeight) {
                    setHeight(`${scrollHeight}px`);
                }
                setTimeout(() => {
                    setHeight('auto');
                }, 150);
            }
            else if (isActiveVar === false) {
                if (scrollHeight) {
                    setHeight(`${scrollHeight}px`);
                }
                setTimeout(() => {
                    setHeight('0');
                }, 1);
            }
        }
        function setPanelHeight() {
            if (isActiveVar) {
                setHeight('auto');
            }
            else if (isActiveVar === false) {
                setHeight('0');
            }
        }
        setAriaControls(ariaControls || nanoid());
        setAriaLabelledBy(ariaLabelledBy || nanoid());
        setInitialPanelHeight();
        window.addEventListener('resize', setPanelHeight);
        return () => {
            window.removeEventListener('resize', setPanelHeight);
        };
    }, [isActiveVar, ariaLabelledBy, ariaControls]);
    function togglePanel() {
        if (!disabled) {
            if (isActiveVar) {
                setIsActive(false);
            }
            else {
                setIsActive(true);
            }
        }
    }
    const componentClassName = classnames('sparky-c-accordion-panel', className, {
        'sparky-is-active': isActiveVar === true,
        'sparky-c-accordion-panel__disabled': disabled === true,
    });
    return (_jsxs("div", Object.assign({ className: componentClassName }, other, { ref: panelRef }, { children: [_jsx("dt", Object.assign({ className: "sparky-c-accordion-panel__header" }, { children: _jsxs("button", Object.assign({ className: "sparky-c-accordion-panel__button", "aria-expanded": isActiveVar, id: ariaLabelledByVar, "aria-controls": ariaControlsVar, onClick: togglePanel, type: "button" }, { children: [header, _jsxs("div", Object.assign({ className: "sparky-c-accordion-panel__right" }, { children: [titleAfter && (_jsx("div", Object.assign({ className: "sparky-c-accordion-panel__title-after" }, { children: titleAfter }))), _jsx(Icon, { className: "sparky-c-accordion-panel__icon", name: "chevron-down", size: iconSize })] }))] })) })), _jsx("dd", Object.assign({ className: "sparky-c-accordion-panel__body", "aria-labelledby": ariaLabelledByVar, id: ariaControlsVar, style: { height: heightVar } }, { children: _jsx("div", Object.assign({ className: "sparky-c-accordion-panel__body-inner" }, { children: children })) }))] })));
};
//# sourceMappingURL=AccordionPanel.js.map